import Grid from '@material-ui/core/Grid'
import CircularProgress from '@material-ui/core/CircularProgress'
import theme, { specialTheme } from '../theme'
import React from 'react'
import { useStyles } from '../pages/styled'

const CircleLoadLayout = () => {
  const classes = useStyles(theme)
  return (
    <Grid className={classes.root}>
      <Grid
        sm={12}
        xl={12}
        xs={12}
        container
        direction="row"
        className={classes.gridMainForm}
      >
        <Grid
          sm={12}
          xl={12}
          xs={12}
          item
          className={classes.loadCircle}
          spacing={2}
        >
          <div color={specialTheme.colors.darkRed}>
            <CircularProgress
              // @ts-ignore
              color="inherit"
              size="2rem"
            />
          </div>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CircleLoadLayout
